import Image from "@/components/image";
import Text from "@/components/text/text";
import { useAppStore } from "@/store/appStore";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useModelViewerStore } from "@/store/modelViewerStore";
import {
  getDeviceType,
  checkCameraPermission,
  requestCameraPermission,
  checkGyroscopePermission,
  requestGyroscopePermission,
} from "src/utils/game";
import { useNavigate } from "react-router-dom";

export default function AugmentedRealityDemoButton() {
  let navigate = useNavigate();
  const deviceType = getDeviceType();

  const OnArButtonClicked = async () => {
    console.log("AR " + deviceType);
    if (deviceType == "desktop") {
      navigate("/AugmentedRealityViewer");
    } else {
      const gyroscopeStatus = await requestGyroscopePermission();
      console.log(gyroscopeStatus);
      if (gyroscopeStatus == "granted") {
        navigate("/AugmentedRealityViewer");
      } else {
        alert("Motion denied");
      }
    }
  };

  return (
    <div
      className={`flex items-center justify-between p-4 cursor-pointer rounded-lg transition-colors duration-200 example-item`}
      onClick={OnArButtonClicked}
    >
      <Text text={"AR"} className="text-white" />
      <Image
        aria-hidden
        src="/assets/icon_next.png"
        alt="next icon"
        width={20}
        height={20}
      />
    </div>
  );
}
